import React from "react";
import { Quote, Instagram } from "lucide-react";

const FOUNDER_IMG =
  "https://customer-assets.emergentagent.com/job_crowdfund-ocean/artifacts/1pt7oqw6_perfil%20change.jpg";

export default function Founder() {
  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="relative py-24 sm:py-32 bg-slate-950/50"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center">
          {/* Portrait */}
          <div className="relative">
            <div className="relative rounded-[2rem] overflow-hidden aspect-[4/5] max-w-md lg:max-w-none">
              <img
                src={FOUNDER_IMG}
                alt="Fundadora de Sin Aletas No Hay Paraíso"
                className="w-full h-full object-cover"
                data-testid="founder-image"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/60 via-transparent to-transparent" />
            </div>
            <div className="absolute -bottom-6 -right-4 bg-rose-500/15 border border-rose-400/30 backdrop-blur-xl rounded-2xl px-5 py-4 max-w-[250px]">
              <div className="text-xs uppercase tracking-[0.2em] font-medium text-rose-300 mb-1">
                European Climate Pact Ambassador
              </div>
              <div className="font-heading text-base font-semibold leading-tight">
                de la Comisión Europea
                <span className="block text-cyan-300 text-sm font-medium mt-1">
                  16 años
                </span>
              </div>
            </div>
          </div>

          {/* Bio */}
          <div data-testid="founder-bio">
            <span className="text-xs uppercase tracking-[0.2em] font-medium text-cyan-400">
              La fundadora
            </span>
            <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight mt-4 mb-7 leading-[1.05]">
              Natalia Rodríguez,
              <br />
              <span className="text-slate-400">detrás del paraíso.</span>
            </h2>

            <div className="relative pl-6 border-l-2 border-cyan-400/50 mb-8">
              <Quote className="absolute -left-3 -top-2 w-5 h-5 text-cyan-400 bg-slate-950 p-0.5 rounded-full" />
              <p className="font-heading text-xl sm:text-2xl text-white leading-snug font-medium italic">
                "Vivo el mar desde todos los ángulos: lo estudio, lo buceo, lo pinto, lo divulgo
                y lo defiendo."
              </p>
            </div>

            <div className="space-y-4 text-slate-300 leading-relaxed">
              <p>
                Divulgadora ambiental, apneista, buceadora y patrona de embarcaciones.{" "}
                <span className="text-white font-medium">
                  Embajadora del Pacto Climático Europeo
                </span>{" "}
                y una de las voces emergentes de la divulgación marina y climática en España.
              </p>
              <p>
                Su vínculo con el océano empezó desde niña. Con solo{" "}
                <span className="text-cyan-300 font-semibold">11 años</span> creó{" "}
                <span className="text-white font-medium">"12 metros"</span>, un proyecto artesanal de
                figuras marinas en arcilla para financiar su formación como buceadora, que alcanzó
                repercusión nacional en televisión, radio y prensa.
              </p>
              <p>
                Hoy compagina sus estudios de Cultivos Acuícolas con proyectos de divulgación y
                conservación, colabora en el programa radiofónico{" "}
                <span className="text-white">"Al otro lado del espejo"</span> entrevistando a
                científicos y biólogos marinos, e impulsa campañas como{" "}
                <span className="text-white">"132 decibelios"</span> sobre el impacto del ruido
                submarino en los cetáceos del Estrecho de Gibraltar.
              </p>
              <p className="text-slate-400">
                Con{" "}
                <span className="text-white font-medium">"Sin aletas no hay paraíso"</span>{" "}
                lleva un libro solidario y un programa de charlas a centros educativos e
                instituciones para concienciar sobre la protección de los tiburones y recaudar fondos
                para la conservación de los océanos.
              </p>
            </div>

            <div className="flex items-center gap-3 mt-9">
              <a
                href="https://www.instagram.com/nataliadiving/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="founder-social-instagram"
                className="inline-flex items-center gap-2.5 rounded-full bg-slate-900/60 border border-white/10 hover:border-cyan-400/50 hover:bg-cyan-500/10 pl-3 pr-5 py-2.5 transition-all group"
                aria-label="Instagram de Natalia"
              >
                <span className="w-7 h-7 rounded-full bg-gradient-to-br from-pink-500 via-rose-500 to-amber-400 flex items-center justify-center">
                  <Instagram className="w-3.5 h-3.5 text-white" />
                </span>
                <span className="text-sm text-slate-200 group-hover:text-cyan-300 transition-colors font-medium">
                  @nataliadiving
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
